var exports = {
  "v": "xcc377c0b--7b54e0--tabs",
};

module.exports = exports;
